'use client';

import { useTranslations } from 'next-intl';
import React, { useState } from 'react';

import Button from '@/components/button/Button';
import JobsModal from '@/components/JobsModal';

import { CinemaLinkDto } from '@cineamo/api/models/cinema-link/CinemaLinkDto.types';

import { cn } from '@cineamo/ui/src/helpers/cn';

import ImageWithTransition from '@cineamo/ui/src/image/ImageWithTransition';

import { useAnalytics } from '@cineamo/composables/src/providers/analyticsProvider';

type JobSectionProps = {
    jobLinks: CinemaLinkDto[];
};

function JobSection(props: JobSectionProps): React.JSX.Element {
    const { jobLinks } = props;

    const t = useTranslations();
    const { track } = useAnalytics();

    const [jobsModalIsOpen, setJobsModalIsOpen] = useState(false);

    return (
        <>
            {jobsModalIsOpen && (
                <JobsModal
                    modalIsOpen={jobsModalIsOpen}
                    setModalIsOpen={setJobsModalIsOpen}
                    jobLinks={jobLinks}
                />
            )}

            <section>
                <div className="h-full rounded-8 overflow-hidden bg-[var(--surface-color)]">
                    <div className="relative flex p-16 h-full">
                        <div className={cn('absolute w-full h-full left-0 bottom-0')}>
                            <ImageWithTransition
                                className={cn(
                                    'w-full h-full absolute right-0 bottom-0',
                                    'object-cover object-left-bottom'
                                )}
                                src={'/im-job.jpg'}
                                width={1000}
                                height={1000}
                                alt=""
                            />
                            <div className="absolute block left-0 top-0 w-full h-full bg-darkBlue/40" />
                        </div>
                        <div className="relative w-full flex flex-col my-autopy-48 px-24 space-y-16">
                            <div className="flex flex-col my-auto pb-12 space-y-16 text-white">
                                <div className="text-headline-20 text-center">
                                    {t('home.looking-for-reinforcement')}
                                </div>
                                <div className="self-center">
                                    <Button
                                        className="bg-[var(--primary-color)] text-[var(--on-primary-color)]"
                                        onClick={() => {
                                            track('Job Card Clicked');
                                            setJobsModalIsOpen(true);
                                        }}>
                                        {t('home.go-to-jobs')}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default JobSection;
